import { ArrowLineDown, ArrowsLeftRight } from '@phosphor-icons/react';

import pt from '../../locales/pt';
import { Button } from '../ui/Button';

/**
 * @param {{ onDeposit: () => void, onMove: () => void, moveDisabled?: boolean }} props
 */
export function PotsFooterActions({ onDeposit, onMove, moveDisabled = false }) {
  return (
    <div className="flex gap-2.5 pt-2">
      <Button
        type="button"
        variant="primary"
        className="h-12 flex-1 rounded-[0.8125rem] shadow-[0_12px_22px_-12px_rgba(95,126,84,0.9)]"
        onClick={onDeposit}
      >
        <ArrowLineDown className="h-4 w-4" aria-hidden />
        {pt.pots.contribute.submit}
      </Button>
      <Button
        type="button"
        variant="outline"
        className="h-12 flex-1 rounded-[0.8125rem] border-[1.5px]"
        onClick={onMove}
        disabled={moveDisabled}
        data-testid="pots-move-cta"
        aria-label={pt.pots.move.cta}
      >
        <ArrowsLeftRight className="h-4 w-4" aria-hidden />
        {pt.pots.move.cta}
      </Button>
    </div>
  );
}
